var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTabinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.934 4.267c.034 0 .07.003.104.01a.556.556 0 01.36.266.533.533 0 01.069.257V8A.533.533 0 116.4 8V6.087l-5.489 5.49a.534.534 0 01-.755-.754l5.49-5.49H3.734a.533.533 0 110-1.066h3.2zM10.667 0a1.066 1.066 0 011.067 1.067v9.6a1.067 1.067 0 01-1.067 1.066H6.934a.533.533 0 010-1.066h3.733v-9.6h-9.6V4.8A.533.533 0 010 4.8V1.067A1.067 1.067 0 011.067 0h9.6z",
    fill: "currentColor"
  })));
}
export default SvgNewTabinline;